import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={129.89}
      height={62.94}
      viewBox="0 0 129.89 62.94"
      {...props}
    >
      <g data-name="Group 699">
        <g data-name="Filled outline">
          <path
            data-name="Path 1597"
            d="M90.38 34.807h22.578v1.881a1.881 1.881 0 01-1.878 1.882H92.261a1.881 1.881 0 01-1.881-1.882z"
            fill="#165a9f"
          />
          <path
            data-name="Path 1598"
            d="M94.143 38.57h15.052v3.763H94.143z"
            fill="#2d75bb"
          />
          <path
            data-name="Path 1599"
            d="M98.847 42.333h5.644v5.644h-5.644z"
            fill="#87cee9"
          />
          <path
            data-name="Path 1600"
            d="M78.151.941l-3.763 5.644v22.578l3.763 5.644h47.037l3.763-5.644V6.585L125.188.941z"
            fill="#003586"
          />
          <path
            data-name="Path 1601"
            d="M80.032 4.704l-1.881 2.822v20.7l1.881 2.822h43.274l1.881-2.822v-20.7l-1.881-2.822z"
            fill="#ffd200"
          />
          <path
            data-name="Path 1602"
            d="M74.388 11.289h3.763v13.17h-3.763z"
            fill="#003586"
          />
          <path
            data-name="Path 1603"
            d="M125.187 11.289h3.763v13.17h-3.763z"
            fill="#003586"
          />
          <path
            data-name="Path 1604"
            d="M81.913 12.23h39.511v3.763H81.913z"
            fill="#cf1e22"
          />
          <path
            data-name="Path 1605"
            d="M81.913 19.756h39.511v3.763H81.913z"
            fill="#cf1e22"
          />
          <g data-name="Group 152" fill="#fff">
            <path data-name="Path 1606" d="M81.913 7.526h1.881v1.881h-1.881z" />
            <path data-name="Path 1607" d="M85.676 7.526h1.881v1.881h-1.881z" />
            <path data-name="Path 1608" d="M89.439 7.526h1.881v1.881h-1.881z" />
            <path data-name="Path 1609" d="M93.202 7.526h1.881v1.881h-1.881z" />
            <path data-name="Path 1610" d="M96.965 7.526h1.881v1.881h-1.881z" />
            <path
              data-name="Path 1611"
              d="M104.491 7.526h1.881v1.881h-1.881z"
            />
            <path
              data-name="Path 1612"
              d="M108.254 7.526h1.881v1.881h-1.881z"
            />
            <path
              data-name="Path 1613"
              d="M112.016 7.526h1.881v1.881h-1.881z"
            />
            <path
              data-name="Path 1614"
              d="M115.779 7.526h1.881v1.881h-1.881z"
            />
            <path
              data-name="Path 1615"
              d="M119.542 7.526h1.881v1.881h-1.881z"
            />
            <path
              data-name="Path 1616"
              d="M100.728 7.526h1.881v1.881h-1.881z"
            />
            <path
              data-name="Path 1617"
              d="M81.913 26.341h1.881v1.881h-1.881z"
            />
            <path
              data-name="Path 1618"
              d="M85.676 26.341h1.881v1.881h-1.881z"
            />
            <path
              data-name="Path 1619"
              d="M89.439 26.341h1.881v1.881h-1.881z"
            />
            <path
              data-name="Path 1620"
              d="M93.202 26.341h1.881v1.881h-1.881z"
            />
            <path
              data-name="Path 1621"
              d="M96.965 26.341h1.881v1.881h-1.881z"
            />
            <path
              data-name="Path 1622"
              d="M104.491 26.341h1.881v1.881h-1.881z"
            />
            <path
              data-name="Path 1623"
              d="M108.254 26.341h1.881v1.881h-1.881z"
            />
            <path
              data-name="Path 1624"
              d="M112.016 26.341h1.881v1.881h-1.881z"
            />
            <path
              data-name="Path 1625"
              d="M115.779 26.341h1.881v1.881h-1.881z"
            />
            <path
              data-name="Path 1626"
              d="M119.542 26.341h1.881v1.881h-1.881z"
            />
            <path
              data-name="Path 1627"
              d="M100.728 26.341h1.881v1.881h-1.881z"
            />
          </g>
          <path
            data-name="Path 1628"
            d="M77.647 0l-4.2 6.3v23.145l4.2 6.3h11.792v.941a2.822 2.822 0 002.822 2.822h.941v3.763h4.7v5.644h7.526v-5.641h4.7v-3.763h.941a2.822 2.822 0 002.822-2.822v-.941h11.8l4.2-6.3V6.3l-4.2-6.3zm-2.319 12.23h1.882v11.288h-1.882zm28.219 34.807h-3.759v-3.763h3.759zm4.7-5.644H95.084v-1.882h13.17zm3.763-4.7a.941.941 0 01-.941.941H92.262a.941.941 0 01-.941-.941v-.941h20.7zm15.992-7.808l-3.325 4.986H78.654l-3.326-4.99V25.4h1.882v3.1l2.319 3.481h44.28l2.319-3.481v-3.1h1.881zm-6.578-17.596h-39.51a.941.941 0 00-.941.941v.941h-1.882V7.808l1.444-2.164h42.268l1.444 2.164v5.362h-1.882v-.94a.941.941 0 00-.941-.941zm-.941 1.881v1.881H82.854V13.17zm-39.51 1.882v.941a.941.941 0 00.941.941h39.51a.941.941 0 00.941-.941v-.941h1.882V20.7h-1.882v-.941a.941.941 0 00-.941-.941h-39.51a.941.941 0 00-.941.941v.941h-1.882v-5.648zm39.511 5.648v1.881h-37.63V20.7zm-39.511 1.878v.941a.941.941 0 00.941.941h39.51a.941.941 0 00.941-.941v-.941h1.882v5.362l-1.444 2.16H80.535l-1.444-2.16v-5.362zm47.037.941h-1.882V12.23h1.881zm0-13.17h-1.882v-3.1l-2.319-3.486h-44.28L77.21 7.244v3.1h-1.882V6.867l3.326-4.986h46.03l3.325 4.986z"
          />
          <path data-name="Path 1629" d="M81.913 7.526h1.881v1.881h-1.881z" />
          <path data-name="Path 1630" d="M85.676 7.526h1.881v1.881h-1.881z" />
          <path data-name="Path 1631" d="M89.439 7.526h1.881v1.881h-1.881z" />
          <path data-name="Path 1632" d="M93.202 7.526h1.881v1.881h-1.881z" />
          <path data-name="Path 1633" d="M96.965 7.526h1.881v1.881h-1.881z" />
          <path data-name="Path 1634" d="M104.491 7.526h1.881v1.881h-1.881z" />
          <path data-name="Path 1635" d="M108.254 7.526h1.881v1.881h-1.881z" />
          <path data-name="Path 1636" d="M112.017 7.526h1.881v1.881h-1.881z" />
          <path data-name="Path 1637" d="M115.78 7.526h1.881v1.881h-1.881z" />
          <path data-name="Path 1638" d="M119.543 7.526h1.881v1.881h-1.881z" />
          <path data-name="Path 1639" d="M100.728 7.526h1.881v1.881h-1.881z" />
          <path data-name="Path 1640" d="M81.913 26.341h1.881v1.881h-1.881z" />
          <path data-name="Path 1641" d="M85.676 26.341h1.881v1.881h-1.881z" />
          <path data-name="Path 1642" d="M89.439 26.341h1.881v1.881h-1.881z" />
          <path data-name="Path 1643" d="M93.202 26.341h1.881v1.881h-1.881z" />
          <path data-name="Path 1644" d="M96.965 26.341h1.881v1.881h-1.881z" />
          <path data-name="Path 1645" d="M104.491 26.341h1.881v1.881h-1.881z" />
          <path data-name="Path 1646" d="M108.254 26.341h1.881v1.881h-1.881z" />
          <path data-name="Path 1647" d="M112.017 26.341h1.881v1.881h-1.881z" />
          <path data-name="Path 1648" d="M115.78 26.341h1.881v1.881h-1.881z" />
          <path data-name="Path 1649" d="M119.543 26.341h1.881v1.881h-1.881z" />
          <path data-name="Path 1650" d="M100.728 26.341h1.881v1.881h-1.881z" />
        </g>
        <g data-name="Filled outline" transform="translate(.001 15.039)">
          <path
            data-name="Path 1573"
            d="M4.79 40.716h38.321v6.387H4.79z"
            fill="#195c85"
          />
          <path
            data-name="Path 1574"
            d="M38.32 27.942V15.168a14.37 14.37 0 10-28.741 0v12.774l-1.596 3.194v9.58h31.934v-9.58z"
            fill="#da1c4b"
          />
          <path
            data-name="Path 1575"
            d="M7.983 31.136h31.934v9.58H7.983z"
            fill="#165a9f"
          />
          <circle
            data-name="Ellipse 46"
            cx={4.081}
            cy={4.081}
            transform="translate(20.114 12.51)"
            fill="#fcf05a"
            r={4.081}
          />
          <path
            data-name="Path 1576"
            d="M43.111 39.918h-2.4v-8.782a.8.8 0 00-.08-.357l-1.517-3.025V15.169a15.169 15.169 0 10-30.337 0v12.585l-1.513 3.025a.8.8 0 00-.084.357v8.782H4.792a.8.8 0 00-.8.8V47.1a.8.8 0 00.8.8h38.319a.8.8 0 00.8-.8v-6.384a.8.8 0 00-.8-.798zM10.074 28.741h16.272v-1.6H10.379V15.169a13.572 13.572 0 1127.144 0v11.975h-3.194v1.6h3.5l.8 1.6H9.276zm-1.292 3.193h1.6v6.387h1.6v-6.387h1.6v6.387h1.6v-6.387h1.6v6.387h1.6v-6.387h1.6v6.387h1.6v-6.387h1.6v6.387h1.6v-6.387h1.6v6.387h1.6v-6.387h1.6v6.387h1.6v-6.387h1.6v6.387h1.6v-6.387h1.6v6.387h1.6v-6.387h1.6v7.984h-30.4zM42.313 46.3H5.592v-4.79h36.721z"
          />
          <path data-name="Path 1577" d="M31.136 27.144h1.6v1.6h-1.6z" />
          <path data-name="Path 1578" d="M27.942 27.144h1.6v1.6h-1.6z" />
          <path
            data-name="Path 1579"
            d="M34.329 15.168v2.4h1.6v-2.4A11.989 11.989 0 0023.954 3.193h-1.6v1.6h1.6a10.391 10.391 0 0110.375 10.375z"
          />
          <path data-name="Path 1580" d="M34.329 19.16h1.6v1.6h-1.6z" />
          <path
            data-name="Path 1581"
            d="M11.407 21.789l3.992-3.992 1.131 1.132-3.992 3.991z"
          />
          <path
            data-name="Path 1582"
            d="M13.003 24.184l3.992-3.992 1.131 1.132-3.992 3.991z"
          />
          <path data-name="Path 1583" d="M0 15.967h7.185v1.6H0z" />
          <path
            data-name="Path 1584"
            d="M1.88 10.992l1.024-1.229 4.788 3.99-1.024 1.23z"
          />
          <path
            data-name="Path 1585"
            d="M1.879 22.534l4.788-3.99 1.024 1.228-4.788 3.99z"
          />
          <path data-name="Path 1586" d="M40.716 15.967h7.185v1.6h-7.185z" />
          <path
            data-name="Path 1587"
            d="M40.195 13.766l4.788-3.99 1.024 1.228-4.788 3.99z"
          />
          <path
            data-name="Path 1588"
            d="M40.192 19.78l1.024-1.229 4.788 3.99-1.024 1.23z"
          />
          <path
            data-name="Path 1589"
            d="M23.95 11.975a4.79 4.79 0 104.79 4.79 4.79 4.79 0 00-4.79-4.79zm0 7.984a3.193 3.193 0 113.193-3.193 3.193 3.193 0 01-3.193 3.193z"
          />
        </g>
      </g>
    </svg>
  )
}

export default SvgComponent
